<template>
    <div class="col-12">
        <div>
            <b><p class="text-to-increase mb-1">{{t('Location on site')}}</p></b>
            <span class="sublocation text-to-increase d-none" v-for="address in geocodeLocations" v-html="address" :key="address">
            </span>
        </div>
        <div v-for="location in locations" :key="location" class="location-box mb-3">
            <div v-if="location.name" class="row"><div class="col-12">{{ location.name }}</div></div>
            <div v-if="location.address" class="row"><div class="col-12">{{ location.address }}</div></div>
            <div v-if="location.zip_code || location.city || location.state || location.country" class="row"><div class="col-12">{{ getSeparated(location, ['zip_code', 'city', 'state', 'country'], ', ', 'values') }}</div></div>
            <div v-if="location.description" class="row"><div class="col-12">{{ t('Notes:') }} {{ location.description }}</div></div>
        </div>    
        <div ref="mapContainer" class="map-section"></div>    
    </div>
</template>
<script>
import formapprendoVue from '../../../apprendo/main/search/components/formapprendo.vue';
export default {
    name: "LocationMap",
    props: ['locations'],
    data: function() {
        return {
            geocodeLocations: [],
            hasLocation: true,                  
        };
    },    
    methods: {
        initMap() {         
                   
            const map = new google.maps.Map(this.$refs.mapContainer, {zoom: 17});
            const bounds = new google.maps.LatLngBounds();

          

            this.geocodeLocations.splice(0, this.geocodeLocations.length);

            //Add markers
            this.locations.forEach((location) => {
                const locationLatLng = new google.maps.LatLng({lat: location.lat, lng: location.lon});

                const marker = new google.maps.Marker({
                    position: locationLatLng,
                    map: map,
                    title: location.name? location.name : null
                });

                bounds.extend(marker.position);

                let formattedAddress = [location.name,
                                            location.address,
                                            location.zip_code,
                                            location.city,
                                            location.state,
                                            location.country].filter(ld=>!!ld).join(', ');
                if(location.description){
                    formattedAddress += `<br>${this.t('Notes:')} ${location.description}`;
                }

                this.geocodeLocations.push(formattedAddress);             

                let infoText = location.name;

                if (location.description) {
                    infoText += " : " + location.description;
                }

                const infoWindow = new google.maps.InfoWindow({
                    content: infoText
                });

                if(!location.address) {
                    marker.setMap(null);
                } else {
                    marker.addListener('click', function() {
                        infoWindow.open(map, marker);
                    });
                }
            });

            if (this.locations.length > 1) {
                map.fitBounds(bounds);
            } else {
                map.setCenter(bounds.getCenter());
            }
        },
        getSeparated(dataObject, keyList, separator, type) {
            const keysExist = keyList.filter(k=>!!dataObject[k]);
            switch(type) {
                case 'values':
                    return keysExist.map(k=>dataObject[k]).join(separator);
                    break;
                case 'titles':
                    let titles = {
                        zip_code: this.t('Zip code'),
                        city: this.t('City'),
                        state: this.t('States'),
                        country: this.t('Country'),
                    };
                    return keysExist.map(k=>titles[k]||k).join(separator);
                    break;
            }
        },
    },
    mounted: function () {
       
        this.$nextTick(() => {
            window.googleMapsLoaded = () => {
                 this.initMap();
            };          
          
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAdmGvruwH0eh2pa9b3sY3bdlfnVz15BM4&callback=googleMapsLoaded`;
            script.defer = true;
            script.async = true;

            // Agrega el script al head del documento          
            document.head.appendChild(script);

           
        });
       
    },
}
</script>

<style scoped>
.location-box {
    color: rgb(56,56,56);
    font-size: 1rem;
    line-height: 1.375rem;
}
</style>
